var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "button-slot" }, [
    _c(
      "a",
      {
        staticClass: "button button--primary",
        class: "button--" + _vm.colourProp,
        attrs: { href: _vm.urlProp }
      },
      [_vm._v(_vm._s(_vm.labelProp))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }